import {SET_FORM_DATA} from "../giaReducer";


const initialState = {
    year: new Date().getFullYear(),
    org: "0",
    school: "0"
};

export const formReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_FORM_DATA:
            return action.payload;
        default:
            return state;
    }
};
